import { Box, Paper, Typography } from "@mui/material";
import { NotificationsNoneOutlined } from "@mui/icons-material";
import { Callout, PageHeader } from "@components/ui_v2";
import useLoanStatusPolling from "@hooks/useLoanStatusPolling";
import { STATUS_CATALOG } from "@helpers/constantes";

/**
 * Sala de espera de WuWei (`WWH_Waiting` del prototipo, sobre `PF_Waiting`): se analiza la actividad del conductor
 * para armar la oferta. Pantalla fija con spinner; como la genérica, sondea la solicitud hasta que el backend decide
 * (`useLoanStatusPolling`).
 */
export const WaitingRoomWuWei = () => {
  useLoanStatusPolling(STATUS_CATALOG.waiting_room.code, "WaitingRoomWuWei");

  return (
    <Box>
      <PageHeader
        eyebrow="Análisis de tu actividad"
        title="¡Listo! Estamos revisando tu perfil"
        subtitle="Analizamos tu actividad como conductor para armar tu oferta. ¡Recibirás respuesta muy pronto!"
      />

      {/* `.card.empty` del prototipo: spinner en un cuadro con el tono de la marca. */}
      <Paper variant="lendia_paper" sx={{ textAlign: "center", p: "56px 24px" }}>
        <Box
          sx={{
            width: 88,
            height: 88,
            mx: "auto",
            mb: "18px",
            borderRadius: "22px",
            display: "grid",
            placeItems: "center",
            bgcolor: "primary.base",
            border: "1px solid",
            borderColor: "primary.light",
          }}
        >
          <Box
            data-testid="waiting-room-wuwei-spinner"
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              border: "3px solid",
              borderColor: "primary.light",
              borderTopColor: "primary.main",
              animation: "waiting-wuwei-spin 0.9s linear infinite",
              "@keyframes waiting-wuwei-spin": { to: { transform: "rotate(360deg)" } },
            }}
          />
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 600, color: "primary.dark", mb: 1 }}>
          Analizando tu perfil de conductor…
        </Typography>
        <Typography variant="body2" sx={{ color: "tokens.textSecondary", maxWidth: 420, mx: "auto" }}>
          Revisamos tus viajes y tus ganancias en plataformas para calcular la renta que te conviene.
        </Typography>
      </Paper>

      <Box sx={{ mt: 2 }}>
        <Callout tone="info" icon={<NotificationsNoneOutlined sx={{ fontSize: 16 }} />}>
          <strong>¡Despreocúpate!</strong> Puedes salir de esta pantalla. Cuando tu oferta personalizada esté lista,
          podrás consultarla aquí mismo y te notificaremos vía WhatsApp.
        </Callout>
      </Box>
    </Box>
  );
};
